import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Totes_ds_validate_scanned_toteService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { lookup: string, container_type_id?: number, warehouse_id: number }): 
  Promise<{ result: { Id?: number, ContainerTypeId?: number, LookupCode?: string, StatusId?: number, WarehouseId?: number, Status?: { Name?: string }, Type?: { Name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lookup)) {
      $missingRequiredInParams.push('\'lookup\'');
    }
    if (isNil($inParams.warehouse_id)) {
      $missingRequiredInParams.push('\'warehouse_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/Totes/datasources/ds_validate_scanned_tote/get`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { lookup: string, container_type_id?: number, warehouse_id: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ContainerTypeId?: number, LookupCode?: string, StatusId?: number, WarehouseId?: number, Status?: { Name?: string }, Type?: { Name?: string } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lookup)) {
      $missingRequiredInParams.push('\'lookup\'');
    }
    if (isNil($inParams.warehouse_id)) {
      $missingRequiredInParams.push('\'warehouse_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/Totes/datasources/ds_validate_scanned_tote/getList`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { lookup: string, container_type_id?: number, warehouse_id: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ContainerTypeId?: number, LookupCode?: string, StatusId?: number, WarehouseId?: number, Status?: { Name?: string }, Type?: { Name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lookup)) {
      $missingRequiredInParams.push('\'lookup\'');
    }
    if (isNil($inParams.warehouse_id)) {
      $missingRequiredInParams.push('\'warehouse_id\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/Totes/datasources/ds_validate_scanned_tote/getByKeys`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      lookup: string, container_type_id?: number, warehouse_id: number    }) {
        if(isNil($inParams.lookup)) {
          return true; 
        }
        if(isNil($inParams.warehouse_id)) {
          return true; 
        }
      return false;
    }
}
